import { TemplateFooter, TemplateMeta } from './TemplateParts';

export default function GiftListMerci({ data }) {
  const {
    coupleName,
    rows,
    shortPhrase,
    ctaText,
    showSiteLink,
    siteUrl,
    showQrCode,
    textColor,
    textShadow,
    accentColor,
    titleStyle,
    bodyStyle,
    isPremium
  } = data;

  return (
    <div className="absolute inset-0 p-6 flex flex-col">
      <div className="my-auto w-full max-w-[88%] rounded-[28px] bg-white/90 border border-white/70 p-5 md:p-6 shadow-[0_20px_40px_rgba(43,31,24,0.25)]">
        <div className="flex items-center justify-between">
          <span className="text-[11px] uppercase tracking-[0.18em] text-[#9A6B65] font-semibold">Lista de presentes</span>
          {isPremium ? (
            <span className="rounded-full px-2 py-1 text-[10px] uppercase tracking-[0.14em] font-semibold bg-[#FFF4E5] text-[#9C784C]">
              Premium
            </span>
          ) : null}
        </div>

        <h4 className="mt-4 text-[2.15rem] md:text-[2.95rem] font-bold leading-[1.03]" style={titleStyle}>
          {coupleName}
        </h4>

        <div className="mt-3">
          <TemplateMeta rows={rows} textColor={textColor} textShadow={textShadow} family={bodyStyle.metaFamily} tracking={bodyStyle.metaTracking} />
        </div>

        {shortPhrase ? (
          <p className="mt-4 text-sm md:text-base" style={bodyStyle.style}>
            {shortPhrase}
          </p>
        ) : null}

        {ctaText ? (
          <div className="mt-5 inline-flex rounded-full border border-[#9A6B65]/35 bg-[#FDEBE8] px-4 py-2 text-[11px] uppercase tracking-[0.14em] font-semibold text-[#7F5954]">
            {ctaText}
          </div>
        ) : null}

        <TemplateFooter
          showSiteLink={showSiteLink}
          siteUrl={siteUrl}
          showQrCode={showQrCode}
          textColor={textColor}
          accentColor={accentColor}
        />
      </div>
    </div>
  );
}
